import { Component, ElementRef, EventEmitter, Input, Output, ViewChild } from '@angular/core';
import { VdPlayerComponent } from '../vd-player/vd-player.component';
import { VdCommentsFeedService } from './vd-comments-feed.service';

/*
 * Comments for the album, shown in the side panel.
 * While a video plays they are read and posted through the inline player (the album-video page's PubNub code);
 * before that, for a fan who already watched the album, through the page's comments feed (same channel).
 */
@Component({
  selector: 'app-vd-comments',
  templateUrl: './vd-comments.component.html',
})
export class VdCommentsComponent {
  @Input() player: VdPlayerComponent | null = null;
  @Input() feed: VdCommentsFeedService | null = null;
  /** A guest tried to post without the player (the player asks for sign-in itself). */
  @Output() loginRequired = new EventEmitter<void>();
  @ViewChild('box') box?: ElementRef<HTMLTextAreaElement>;

  get comments(): any[] {
    return (this.player ? this.player.comments : this.feed?.comments) || [];
  }

  get signedIn(): boolean {
    return this.player ? !!this.player.userInfo?.access_token : !!this.feed?.signedIn;
  }

  submit(event?: Event): void {
    event?.preventDefault();
    const text = this.box?.nativeElement.value.trim();
    if (!text || !this.box) return;
    const player = this.player;
    if (!player) {
      if (!this.feed) return;
      if (!this.signedIn) return this.loginRequired.emit();
      this.feed.post(text);
      this.box.nativeElement.value = '';
      return;
    }
    if (!this.signedIn) {
      player.requireLogin();
      return;
    }
    // postComment() resets the album-video page's own textarea; give it this one.
    player.commentInput = this.box;
    player.newComment = text;
    player.postComment();
    this.box.nativeElement.value = '';
  }

  trackByComment(index: number, comment: any): any {
    return comment?.messageId ?? comment?.timestamp ?? index;
  }
}
